export interface IFileModel {
  Id: string;
  Name: string;
  ContainerName: string;
  ContentType: string;
  Size: number;
  Extension: string;
  BlobUrl: string;
  SeqNumber: number;
  ThumbnailSize?: number;
  ThumbnailBlobUrl?: string;
  size?: string;
  IsUserUploadedFile?: boolean;
}

  export interface IFileModelMediaUploader extends IFileModel {
    size?: string;
    isTemporaryUrl?: boolean;
    tempId?: string;
  }

  export interface FilesModel {
    galleryFiles?: IFileModel[];
    documentFiles?: IFileModel[];
  }
